(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["comfi-linked-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('comfi-linked-colors')) {
    class ComfiLinkedColors extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick = (event) => {
        const link = event.target.closest('a[data-product-id]');
        if (!link || !this.contains(link)) return;
        event.stopPropagation();
        if (this.dataset.context !== 'card') return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

        const card = this.closest('product-card');
        const gallery = card?.querySelector('[ref="cardGallery"]');
        const template = card?.querySelector(
          'template[data-comfi-color-gallery="' + link.dataset.productId + '"]'
        );
        const replacement = template?.content.querySelector('[ref="cardGallery"]');
        if (!card || !gallery || !replacement || typeof card.applyVariantToLinks !== 'function') return;

        event.preventDefault();
        gallery.replaceWith(replacement.cloneNode(true));
        card.applyVariantToLinks(null, link.href);
        card.dataset.productId = link.dataset.productId;
        card.dataset.featuredMediaUrl = link.dataset.featuredMediaUrl;

        const overlay = card.querySelector('[ref="productCardLink"]');
        overlay?.setAttribute('aria-label', link.dataset.productTitle);
        const title = card.querySelector('[ref="productTitleLink"]');
        const heading = title?.querySelector('[role="heading"], h1, h2, h3, h4, h5, h6, p');
        if (heading) heading.textContent = link.dataset.productTitle;
        else if (title) title.textContent = link.dataset.productTitle;
        const zoomTitle = card.querySelector('.product-grid-view-zoom-out--details');
        if (zoomTitle) zoomTitle.textContent = link.dataset.productTitle;

        this.querySelectorAll('a[data-product-id]').forEach((swatch) => {
          if (swatch === link) swatch.setAttribute('aria-current', 'true');
          else swatch.removeAttribute('aria-current');
        });
        this.setAttribute('aria-label', link.dataset.productTitle);
      };
    }
    customElements.define('comfi-linked-colors', ComfiLinkedColors);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["comfi-page-transition"] && !Shopify.designMode) return;
  try {
    (() => {
    const overlay = document.querySelector('[data-comfi-page-transition]');

    if (!overlay) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const hideOverlay = () => {
      overlay.classList.remove('is-leaving');
    };

    if (reduceMotion) {
      hideOverlay();
      return;
    }

    hideOverlay();
    window.addEventListener('pageshow', hideOverlay);

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const link = event.target.closest('a[href]');

      if (!link || link.hasAttribute('download') || link.target === '_blank') return;

      const destination = new URL(link.href, window.location.href);

      if (destination.origin !== window.location.origin) return;
      if (destination.pathname === window.location.pathname && destination.search === window.location.search) return;
      if (destination.protocol !== 'http:' && destination.protocol !== 'https:') return;

      event.preventDefault();
      overlay.classList.add('is-leaving');

      window.setTimeout(() => {
        window.location.assign(destination.href);
      }, 760);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
